import React, { useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { menuItems } from "./menuitems";
import CountryDropdown from "../currency-Symbols/currency-symbol";
import logo from '../assets/images/finaculator1.png';

const Header: React.FC = () => {
  const navBarToggleRef = useRef<HTMLButtonElement>(null);
  const location = useLocation();

  const handleNavLinkClick = (to: string) => {
    if (navBarToggleRef.current && navBarToggleRef.current.getAttribute("aria-expanded") === "true") {
      navBarToggleRef.current.click();
    }

    if (location.pathname === to) {
      window.location.reload();
    }
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg" style={{ backgroundColor: "#094ea2" }}>
        <div className="container-fluid">
          <Link className="navbar-brand text-white d-flex align-items-center" to="/"> 
            <img 
              src={logo}
              alt="Logo" 
              style={{ width: '50px', height: '50px', marginRight: '8px', borderRadius: '70%' }} 
            />
            <h3>Finaculator</h3>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            ref={navBarToggleRef}  
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              {menuItems.map((item, index) => (
                <li className="nav-item dropdown" key={index}>
                  <Link
                    className="nav-link dropdown-toggle text-white"
                    to="#"
                    id={`navbarDropdown${index}`}
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {item.title}
                  </Link>
                  <ul className="dropdown-menu" aria-labelledby={`navbarDropdown${index}`}>
                    {item.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <Link
                          className="dropdown-item"
                          to={link.to}
                          onClick={() => handleNavLinkClick(link.to)}
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
              <li className="nav-item">
                <Link className="nav-link text-white" to="/saved" onClick={() => handleNavLinkClick('/saved')}>
                  Saved Calculation
                </Link>
              </li>
              <li className="nav-item">
                <CountryDropdown />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
